import "../../assets/css/policy/TermsOfService.css";
import modalclose from "../../assets/img/ModalClose.svg";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";

const TermsOfService = () => {
  const navigate = useNavigate();

  const onClose = () => navigate(-1);
  const stop = (e) => e.stopPropagation();

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div
      className="tos-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="이용약관"
    >
      <div className="tos-box" onClick={stop}>
        <div className="tos-top">
          <div className="tos-title">이용약관</div>

          <button
            className="tos-close-button"
            onClick={onClose}
            aria-label="닫기"
            type="button"
          >
            <img src={modalclose} className="tos-modalclose-img" alt="닫기" />
          </button>
        </div>

        <div className="tos-divider" aria-hidden="true" />

        <div className="tos-des-all">
          <div className="tos-des">
            <strong>제1조(목적)</strong>
            <br />
            본 약관은 덕성여자대학교 총학생회(이하 “총학생회”)가 운영하고
            관리하는 덕성여자대학교 총학생회 웹사이트(이하 “사이트”)를
            이용하는 데 있어 총학생회와 이용자 간의 권리와 의무 및 책임 사항
            등을 규정함을 목적으로 합니다.
          </div>

          <div className="tos-des">
            <strong>제2조(용어의 정의)</strong>
            <br />① “이용자”는 사이트를 이용하는 모든 자를 의미합니다.
            <br />② “단위”란 사이트 관리 권한을 가진 총학생회 산하 자치
            기구(단과대학, 동아리연합회 등)를 의미합니다.
            <br />③ “계정 정보”란 사이트를 관리하기 위해 총학생회가 정한
            필수 입력 정보로서 관리자가 기입한 모든 정보(이름, 소속 정보,
            단위별 관리자용 아이디와 비밀번호 등)를 통칭합니다.
          </div>

          <div className="tos-des">
            <strong>제3조(약관의 명시 및 개정)</strong>
            <br />① 총학생회는 이용자가 이 약관의 내용을 확인할 수 있도록
            사이트 하단에 게시합니다.
            <br />② 총학생회는 필요한 경우, 관련 법령을 위배하지 않는 범위
            내에서 이 약관을 개정할 수 있습니다. 약관이 개정되는 경우, 시행일
            7일 전부터 사이트에 반영하여 게시합니다.
          </div>

          <div className="tos-des">
            <strong>제4조(약관 외 준칙)</strong>
            <br />이 약관에서 정하지 아니한 사항은 「정보통신망 이용촉진 및
            정보보호 등에 관한 법률」, 「개인정보 보호법」, 「약관의 규제에
            관한 법률」 등 관계법령 또는 관례에 따릅니다.
          </div>

          <div className="tos-des">
            <strong>제5조(관리자 계정 관리)</strong>
            <br />① 총학생회는 원활한 사이트 관리를 위해 각 단위별 관리자
            계정을 관리할 수 있습니다.
            <br />② 관리자는 본인의 계정 정보를 엄격히 관리해야 하며, 타인에게
            대여하거나 유출하여 발생하는 문제에 대한 책임은 관리자 본인에게
            있습니다.
          </div>

          <div className="tos-des">
            <strong>제6조(콘텐츠 저작권)</strong>
            <br />① 사이트에 게시된 모든 콘텐츠(글, 이미지 등)의 저작권은
            총학생회 및 해당 단위에 귀속됩니다.
            <br />② 이용자는 총학생회의 승낙 없이 콘텐츠를 복제, 배포하거나
            상업적으로 이용할 수 없습니다.
          </div>

          <div className="tos-des">
            <strong>제7조(면책 조항)</strong>
            <br />① 총학생회는 사이트에 게시된 정보의 정확성과 신뢰도를 위해
            노력하나, 정보의 완전성이나 최신성을 법적으로 보증하지는 않습니다.
            <br />② 이용자가 사이트에 게시된 정보를 신뢰함으로써 발생한 결과에
            대하여 총학생회는 관리자의 고의 또는 중대한 과실이 없는 한 법적
            책임을 지지 않습니다.
            <br />③ 총학생회는 이용자의 편의를 위해 외부 사이트로 연결되는
            링크를 제공할 수 있으나, 해당 사이트의 정책 및 콘텐츠에 대해서는
            보증하거나 책임을 지지 않습니다.
            <br />④ 사이트 점검, 통신 장애, 천재지변 등 운영상의 불가피한
            사유나 관리자의 통제 범위를 벗어난 사유로 발생한 기술적 문제 및
            사이트 이용 중단에 대해서는 책임을 면합니다.
          </div>

          <div className="tos-des">
            <strong>부칙</strong>
            <br />본 약관은 본 사이트 배포일부터 시행됩니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;